/* tslint:disable */
/* eslint-disable */
/**
 * Adyen Card Enrollment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Data received from Adyen relevant to the drop-in component.
 * @export
 * @interface CreateActionResultResponseDataAdyenData
 */
export interface CreateActionResultResponseDataAdyenData {
    /**
     * 
     * @type {string}
     * @memberof CreateActionResultResponseDataAdyenData
     */
    resultCode: string;
}

export function CreateActionResultResponseDataAdyenDataFromJSON(json: any): CreateActionResultResponseDataAdyenData {
    return CreateActionResultResponseDataAdyenDataFromJSONTyped(json, false);
}

export function CreateActionResultResponseDataAdyenDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateActionResultResponseDataAdyenData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultCode': json['resultCode'],
    };
}

export function CreateActionResultResponseDataAdyenDataToJSON(value?: CreateActionResultResponseDataAdyenData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'resultCode': value.resultCode,
    };
}

